import React, { useState } from "react";
import classnames from "classnames";
import Clickable, { ClickableAction } from "@unum/clickable";
import Heading from "@unum/heading";
import styles from "./Footer.module.scss";
import Logo from "./assets/unum-logo-w.inline.svg";

export type SocialLink = {
  icon: SVGImport;
  accessibilityLabel: React.ReactNode;
  action?: ClickableAction;
};

type Link = {
  label: React.ReactNode;
  action?: ClickableAction;
};

export type Navigation = {
  links: Link[];
  label: React.ReactNode;
};

type Props = {
  socialLinks?: SocialLink[];
  navLinks: Navigation[];
  footer?: React.ReactNode;
};

const Description = ({ children }: { children: React.ReactNode }) => {
  return <p className="footer__copyright-description">{children}</p>;
};

const Footer = ({ socialLinks, navLinks, footer }: Props) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const toggle = (index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };
  return (
    <section className="section section--dark-blue">
      <div className="spring">
        <footer className={classnames(styles["Footer"], "footer")}>
          <div className="footer__wrapper">
            <div className="row">
              <div className="col-xs-12 col-md-3">
                <div className="footer__logo-links">
                  <Logo />
                  {socialLinks && (
                    <ul className="list footer__social-links">
                      {socialLinks.map(
                        ({ icon: Icon, accessibilityLabel, action }, index) => {
                          return (
                            <li
                              key={`social-link-${index}`}
                              className="footer__social-link"
                            >
                              <Clickable {...action}>
                                <Icon />
                                <span className="sr-only">
                                  {accessibilityLabel}
                                </span>
                              </Clickable>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  )}
                </div>
              </div>
              {navLinks.map((link, index) => {
                return (
                  <div key={index} className="col-xs-12 col-md-3">
                    <div
                      className={classnames(
                        "footer__section",
                        index === 0 ? "footer__section--first" : null,
                        activeIndex === index ? "footer__section--active" : null
                      )}
                    >
                      <Heading
                        level={4}
                        component="h2"
                        className="footer__section-heading"
                        onClick={() => toggle(index)}
                      >
                        {link.label}
                      </Heading>
                      <ul className="list footer__section-links ">
                        {link.links.map((navigation, index) => {
                          return (
                            <li key={index}>
                              <Clickable
                                className={classnames(
                                  styles["link"],
                                  "footer__section-link"
                                )}
                                {...navigation.action}
                              >
                                {navigation.label}
                              </Clickable>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="footer__copyright">{footer}</div>
        </footer>
      </div>
    </section>
  );
};

Footer.Description = Description;

export default Footer;
